module.exports = __webpack_public_path__ + "img/search.f549aab4.png";